import { render, staticRenderFns } from "./SftpSecureParameters.vue?vue&type=template&id=6b3e6d8c&scoped=true"
import script from "./SftpSecureParameters.vue?vue&type=script&lang=js"
export * from "./SftpSecureParameters.vue?vue&type=script&lang=js"
import style0 from "./SftpSecureParameters.vue?vue&type=style&index=0&id=6b3e6d8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e6d8c",
  null
  
)

export default component.exports